import { createSignal } from 'rwwa-rx-state-machine'
import { FeatureFlags } from './driver'

export const OnFeatureChange = createSignal<{
  features: FeatureFlags
  isUserAnonymous?: boolean
  isLdInitialized: boolean
}>('OnFeatureChange')
